<template>
  <vx-card :title="tableName" class="w-full">
    <vs-collapse accordion>
      <vs-collapse-item
        v-for="(row, prop) in suggestionData"
        :key="row.id + prop"
      >
        <div slot="header">
          <div class="vx-row justify-between">
            <div class="vx-col">
              <div class="vx-row diag_opp_title fw-bold">
                <vs-chip :color="getColorForScore(row.score)"></vs-chip>
                {{ row.title }}
              </div>
            </div>
            <div
              class="vx-col mr-4 diag_opp_title fw-bold"
              :class="{
                txt_low: row.score <= 0.49,
                txt_medium: row.score >= 0.5 && row.score <= 0.89
              }"
            >
              {{ row.displayValue }}
            </div>
          </div>
        </div>
        <div class="vs-row mt-4 mb-4">
          {{ row.description }}
        </div>

        <!-- DIAGNOSTIC TABLE -->
        <vs-table
          stripe
          :data="row.details.items"
          v-if="Object.keys(row.details.items).length >= 1"
          class="w-full"
        >
          <template slot="thead">
            <vs-th></vs-th>
            <vs-th v-if="row.details.items[0].hasOwnProperty('url')"
              ><span class="w-full">URL</span></vs-th
            >
            <vs-th v-if="row.details.items[0].hasOwnProperty('groupLabel')"
              ><span class="w-full">Catégorie</span></vs-th
            >
            <vs-th v-if="row.details.items[0].hasOwnProperty('resourceType')"
              ><span class="w-full">Type de ressource</span></vs-th
            >
            <vs-th v-if="row.details.items[0].hasOwnProperty('entity')"
              ><span class="w-full">Tiers</span></vs-th
            >
            <vs-th v-if="row.details.items[0].hasOwnProperty('statistic')"
              ><span class="w-full">Statistique</span></vs-th
            >
            <vs-th
              v-if="
                row.details.items[0].hasOwnProperty('totalBytes') ||
                  row.details.items[0].hasOwnProperty('resourceSize')
              "
            >
              <span class="txt_align_right w-full">Taille de la ressource</span>
            </vs-th>
            <vs-th v-if="row.details.items[0].hasOwnProperty('wastedBytes')"
              ><span class="txt_align_right w-full"
                >Économies potentielles</span
              ></vs-th
            >
            <vs-th v-if="row.details.items[0].hasOwnProperty('wastedMs')"
              ><span class="txt_align_right w-full"
                >Économies potentielles</span
              ></vs-th
            >
            <vs-th
              v-if="
                row.details.items[0].hasOwnProperty('label') &&
                  !row.details.items[0].hasOwnProperty('resourceType')
              "
              ><span class="txt_align_right w-full">Emplacement</span></vs-th
            >
            <vs-th v-if="row.details.items[0].hasOwnProperty('requestCount')"
              ><span class="txt_align_right w-full">Requêtes</span></vs-th
            >
            <vs-th v-if="row.details.items[0].hasOwnProperty('node')"
              ><span class="w-full">Element</span></vs-th
            >
            <vs-th v-if="row.details.items[0].hasOwnProperty('score')"
              ><span class="txt_align_right w-full"
                >CLS Contribution</span
              ></vs-th
            >
            <vs-th v-if="row.details.items[0].hasOwnProperty('transferSize')"
              ><span class="txt_align_right w-full"
                >Taille de transfert</span
              ></vs-th
            >
            <vs-th v-if="row.details.items[0].hasOwnProperty('statusCode')"
              ><span class="txt_align_right w-full">Code HTTPS</span></vs-th
            >
            <vs-th
              v-if="
                row.details.items[0].hasOwnProperty('element') ||
                  (row.details.items[0].hasOwnProperty('value') &&
                    row.details.items[0].hasOwnProperty('statistic'))
              "
            >
              <span class="w-full">Element</span>
            </vs-th>
            <vs-th v-if="row.details.items[0].hasOwnProperty('value')"
              ><span class="txt_align_right w-full">Valeur</span></vs-th
            >
            <vs-th
              v-if="
                row.details.items[0].hasOwnProperty('startTime') &&
                  row.details.items[0].hasOwnProperty('duration')
              "
            >
              <span class="txt_align_right w-full">Début</span>
            </vs-th>
            <vs-th v-if="row.details.items[0].hasOwnProperty('duration')"
              ><span class="txt_align_right w-full">Durée</span></vs-th
            >
            <vs-th v-if="row.details.items[0].hasOwnProperty('cacheLifetimeMs')"
              ><span class="txt_align_right w-full"
                >Cache de la valeur TTL</span
              ></vs-th
            >
            <vs-th v-if="row.details.items[0].hasOwnProperty('total')"
              ><span class="txt_align_right w-full"
                >Temps CPU total</span
              ></vs-th
            >
            <vs-th v-if="row.details.items[0].hasOwnProperty('scripting')"
              ><span class="txt_align_right w-full"
                >Évaluation des scripts</span
              ></vs-th
            >
            <vs-th
              v-if="row.details.items[0].hasOwnProperty('scriptParseCompile')"
              ><span class="txt_align_right w-full"
                >Analyse des scripts</span
              ></vs-th
            >
            <vs-th v-if="row.details.items[0].hasOwnProperty('blockingTime')"
              ><span class="txt_align_right w-full"
                >Durée de blocage du thread principal</span
              ></vs-th
            >
          </template>

          <template slot-scope="{ data }">
            <vs-tr :key="index" v-for="(row, index) in data">
              <vs-td class="img_thumbnail">
                <img
                  :src="row.url"
                  class="small_image m-1"
                  :alt="row.url"
                  v-if="imgRegex.test(row.url)"
                />
              </vs-td>
              <vs-td
                :title="row.url"
                v-if="row.hasOwnProperty('url')"
                class="max-w-2/5"
              >
                <span class="url_box">{{ decodeURI(row.url) }}</span>
              </vs-td>
              <vs-td v-if="row.hasOwnProperty('groupLabel')">{{
                row.groupLabel
              }}</vs-td>
              <vs-td v-if="row.hasOwnProperty('entity')">{{
                row.entity.text
              }}</vs-td>
              <vs-td v-if="row.hasOwnProperty('statistic')">{{
                row.statistic
              }}</vs-td>
              <vs-td v-if="row.hasOwnProperty('element')">{{
                row.element.value
              }}</vs-td>
              <vs-td
                class="fw-bold"
                v-if="
                  row.hasOwnProperty('resourceType') &&
                    row.hasOwnProperty('label')
                "
                >{{ row.label }}</vs-td
              >
              <vs-td
                class="fw-bold"
                v-else-if="
                  row.hasOwnProperty('resourceType') &&
                    !row.hasOwnProperty('label')
                "
                >{{ row.resourceType }}</vs-td
              >
              <vs-td
                class="fw-bold txt_align_right"
                v-if="row.hasOwnProperty('totalBytes')"
                >{{
                  formatThousandNumb(
                    parseFloat(row.totalBytes / 1000).toFixed(2)
                  )
                }}
                KB</vs-td
              >
              <vs-td
                class="fw-bold txt_align_right"
                v-if="row.hasOwnProperty('resourceSize')"
                >{{
                  formatThousandNumb(
                    parseFloat(row.resourceSize / 1000).toFixed(2)
                  )
                }}
                KB</vs-td
              >
              <vs-td
                class="fw-bold txt_align_right"
                v-if="
                  row.hasOwnProperty('label') &&
                    !row.hasOwnProperty('resourceType')
                "
                >{{ row.label }}</vs-td
              >
              <vs-td
                class="fw-bold txt_align_right"
                v-if="row.hasOwnProperty('requestCount')"
                >{{ row.requestCount }}</vs-td
              >
              <vs-td
                class="fw-bold txt_align_right"
                v-if="row.hasOwnProperty('wastedBytes')"
                >{{
                  formatThousandNumb(
                    parseFloat(row.wastedBytes / 1000).toFixed(2)
                  )
                }}
                KB</vs-td
              >
              <vs-td
                class="fw-bold txt_align_right"
                v-if="row.hasOwnProperty('wastedMs')"
                >{{ formatThousandNumb(parseInt(row.wastedMs)) }} ms</vs-td
              >
              <vs-td v-if="row.node">
                <div class="vx-col">
                  <div class="vx-row fw-bold">
                    {{ row.node.nodeLabel }}
                  </div>
                  <div class="vx-row">
                    {{ row.node.snippet }}
                  </div>
                </div>
              </vs-td>
              <vs-td
                class="fw-bold txt_align_right"
                v-if="row.hasOwnProperty('score')"
                >{{ row.score }}</vs-td
              >
              <!-- NEED A BLANK SINCE FIRST ROW DOESNT HAVE ELEM PROPERTY -->
              <vs-td
                class="txt_align_right"
                v-if="
                  row.hasOwnProperty('value') &&
                    row.hasOwnProperty('statistic') &&
                    !row.hasOwnProperty('element')
                "
              ></vs-td>
              <vs-td
                class="fw-bold txt_align_right"
                v-if="row.hasOwnProperty('value')"
                >{{ row.value }}</vs-td
              >
              <vs-td
                class="fw-bold txt_align_right"
                v-if="row.hasOwnProperty('transferSize')"
                >{{
                  formatThousandNumb(
                    parseFloat(row.transferSize / 1000).toFixed(2)
                  )
                }}
                KB</vs-td
              >
              <vs-td
                class="fw-bold txt_align_right"
                v-if="row.hasOwnProperty('statusCode')"
                >{{ row.statusCode }}</vs-td
              >
              <vs-td
                class="fw-bold txt_align_right"
                v-if="
                  row.hasOwnProperty('startTime') &&
                    row.hasOwnProperty('duration')
                "
                >{{ formatThousandNumb(row.startTime) }} ms</vs-td
              >
              <vs-td
                class="fw-bold txt_align_right"
                v-if="row.hasOwnProperty('duration')"
                >{{ formatThousandNumb(parseInt(row.duration)) }} ms</vs-td
              >
              <vs-td
                class="fw-bold txt_align_right"
                v-if="row.hasOwnProperty('cacheLifetimeMs')"
                >{{
                  formatThousandNumb(parseInt(row.cacheLifetimeMs / 1000))
                }}
                ms</vs-td
              >
              <vs-td
                class="fw-bold txt_align_right"
                v-if="row.hasOwnProperty('total')"
                >{{ formatThousandNumb(parseInt(row.total)) }} ms</vs-td
              >
              <vs-td
                class="fw-bold txt_align_right"
                v-if="row.hasOwnProperty('scripting')"
                >{{ formatThousandNumb(parseInt(row.scripting)) }} ms</vs-td
              >
              <vs-td
                class="fw-bold txt_align_right"
                v-if="row.hasOwnProperty('scriptParseCompile')"
                >{{
                  formarThousandNumb(parseInt(row.scriptParseCompile))
                }}
                ms</vs-td
              >
              <vs-td
                class="fw-bold txt_align_right"
                v-if="row.hasOwnProperty('blockingTime')"
                >{{ formatThousandNumb(parseInt(row.blockingTime)) }} ms</vs-td
              >
            </vs-tr>
          </template>
        </vs-table>
        <!-- END DIAGNOSTIC TABLE -->
      </vs-collapse-item>
    </vs-collapse>
  </vx-card>
</template>

<script>
import utilsMixin from "@/mixins/utilsMixin";
import pageSpeedScoreMixin from "../../mixins/pageSpeedScoreMixin";

export default {
	name: "SuggestionsTable",
	props: {
		suggestionData: Array,
		tableName: String
	},
	mixins: [utilsMixin, pageSpeedScoreMixin],

	data() {
		return {
			imgRegex: /(http(s?):)([/|.|\w|\s|-])*\.(?:jpg|gif|png)/
		};
	}
};
</script>

<style scoped>
.comparing_div {
  margin: 5px;
  align-items: center;
}
.comparing_container {
  display: none;
  margin: 5px;
  background-color: rgb(245, 245, 245);
  border-radius: 5px;
}

.center {
  display: flex;
  justify-content: center;
}

.vertical_align {
  align-items: center;
}

.radial_container {
  display: flex;
}
.filter_container {
  display: flex;
  justify-content: space-between;
}

.filter_card {
  margin-bottom: 0 !important;
}

.txt_align_right {
  text-align: right;
}

.pointer {
  cursor: pointer;
}

.metric_container {
  max-width: 40%;
  min-width: 30%;
}

.txt_low {
  color: #ff4e42;
}

.txt_medium {
  color: #ffa400;
}

.txt_high {
  color: #20e647;
}

.fw-bold {
  font-weight: bold;
}

.small_image {
  width: 100%;
  height: 50px;
  object-fit: cover;
}

.img_thumbnail {
  max-width: 40px;
  max-height: 50px;
  padding: 0 !important;
}

.diag_opp_title {
  font-size: 0.8em;
}

.limit_text {
  font-weight: 500;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.url_box {
  word-break: break-word;
}

.img_thumbnail {
  width: 8.5% !important;
}
</style>
